import * as React from 'react';
import Footer from '../../components/footer/Footer';

import '../../assets/style_org.css'
import Section from '../../components/section/Section';
import Navbar from '../../components/nav/Navbar';

import {isBrowser, isMobile } from 'react-device-detect';

export default function Organization(){

    const program_commitee_1=[
        "Katija Kalebić Jakupčević\n predsjednica PO-a",
        "Siniša Brlas",
        "Ivan Buljan",
        "Jasminka Despot Lučanin",
        "Zrinka Greblo Jurakić",
    ]

    const program_commitee_2=[
        "Darko Hren",
        "Slobodan Jović",
        "Goran Kardum",
        "Gordana Kuterovac Jagodić",
        "Ivana Macuka",
        
    ]

    const program_commitee_3=[
        "Sandra Nakić Radoš",
        "Alessandra Pokrajac-Bulian",
        "Nelija Rudolfi",
        "Tena Velki",
        "Iva Žegura"
    ]

    const organization_commitee_1 = [
        "Vesna Tudor Pavičić - predsjednica OO-a",
        "Sandra Antišić Čanić",
        "Lara Buljan Gudelj",
        "Jakov Karin",
        "Dina Klarić",

        
    ]

    const organization_commitee_2 = [
        "Ivana Svetina Leš",
        "Anamarija Lončar",
        "Ines Roso Perić",
        "Neda Pleić",
        "Vedrana Ždero",
    ]

    return (
        <>
        <Navbar/>
        <div style={{position:"relative"}} >
            <div className="section-padded-standard background-opaque" style={{minHeight:"80vh", paddingTop:"25vh"}}>
            <Section title={<h1 style={{fontSize:"3rem", fontWeight:"200"}}>Programski i organizacijski <span className="" >odbor</span></h1>} content={
                <div className={isMobile?"flex-column":"flex-row"} style={{justifyContent:"center",  gap:"6%", height:"100%"}}>
                    <div className='flex-column' style={{ width:isMobile?"80%":"50%", height:"100%"}}>
                    <h2 className="pillbox-huge button-huge hpd-green-background pillbox-like" style={{fontSize:isMobile?"1.0rem":"2.2rem", marginBottom:"2rem", fontWeight:"400", width:"100%"}}>Programski odbor</h2>
                    <div className={isMobile?"flex-column":"flex-row"} style={{width:'100%', height:"100%", paddingBottom:"7rem", gap:"2rem"}}>
                    <ul id="prog-1">
                        {
                            program_commitee_1.map((element, i)=>{
                                return <li style={{width:"100%", textAlign:"center"}}  className='comm-member pillbox-like pillbox-huge light-background-element' key={i}>{element}</li>
                            })
                        }
                    </ul>
                    <ul id="prog-2">
                        {
                            program_commitee_2.map((element, i)=>{
                                return <li style={{width:"100%", textAlign:"center"}}  className='comm-member pillbox-like pillbox-huge light-background-element' key={i}>{element}</li>
                            })
                        }
                    </ul>
                    <ul id="prog-3">
                        {
                            program_commitee_3.map((element, i)=>{
                                return <li style={{width:"100%", textAlign:"center"}}  className='comm-member pillbox-like pillbox-huge light-background-element' key={i}>{element}</li>
                            })
                        }
                    </ul>
                </div>
                </div>

                
                <div className='flex-column' style={{ width:isMobile?"80%":"50%", height:"100%"}}>
                    <h2 className="pillbox-huge button-huge hpd-green-background pillbox-like" style={{fontSize:isMobile?"1.0rem":"2.2rem", marginBottom:"2rem", fontWeight:"400", width:"100%"}}>Organizacijski odbor</h2>
                <div className={isMobile?"flex-column":"flex-row"} style={{justifyContent:"center",width:'100%', height:"100%", paddingBottom:"7rem", gap:"2rem" }}>
                
                    <ul id="org-ul" >
                    {
                            organization_commitee_1.map((element, i)=>{
                                return <li className='comm-member pillbox-like pillbox-huge light-background-element' style={{width:"100%", textAlign:"center"}} key={i}>{element}</li>
                            })
                        }
                    </ul>
                    <ul id="org-ul" >
                    {
                            organization_commitee_2.map((element, i)=>{
                                return <li className='comm-member pillbox-like pillbox-huge light-background-element' style={{width:"100%", textAlign:"center"}} key={i}>{element}</li>
                            })
                        }
                    </ul>
                    </div>
                </div>
                </div>
            }/>
            </div>
        <Footer/>
    </div>
    </>
    
)
}